export const LOGIN_AS_ALLOWED_EMAIL_DOMAINS = ["infoplaza.nl", "infoplaza.com"] as const;

export const LOGIN_AS_TOKEN_TTL_MS = 15 * 60 * 1000;

export const LOGIN_AS_SESSION_COOKIE_TTL_MS = 24 * 60 * 60 * 1000;

export const LOGIN_AS_SESSION_COOKIE = "waas-login-as";

export const LOGIN_AS_TOKEN_HASH_PARAM = "token";

export const LOGIN_AS_MUTATING_HTTP_METHODS = ["POST", "PUT", "PATCH", "DELETE"] as const;

export const LOGIN_AS_FAILURE_REASON = {
  USER_NOT_FOUND: "USER_NOT_FOUND",
  INELIGIBLE_EMAIL: "INELIGIBLE_EMAIL",
  ALREADY_OPERATOR: "ALREADY_OPERATOR",
  NOT_FOUND: "NOT_FOUND",
  TARGET_NOT_FOUND: "TARGET_NOT_FOUND",
  MISCONFIGURED: "MISCONFIGURED",
  NOT_IMPERSONATING: "NOT_IMPERSONATING",
} as const;

export const LOGIN_AS_MODE = {
  VIEW: "view",
  EDIT: "edit",
} as const;

export type LoginAsMode = (typeof LOGIN_AS_MODE)[keyof typeof LOGIN_AS_MODE];

export const LOGIN_AS_VIEW_MODE_ERROR = "LOGIN_AS_VIEW_MODE";

export const LOGIN_AS_VIEW_MODE_USER_MESSAGE =
  "Enable edit mode to make changes while logged in as another user.";

export const LOGIN_AS_NOT_OPERATOR_ERROR = "LOGIN_AS_NOT_OPERATOR";

export const LOGIN_AS_INVALID_TOKEN_ERROR = "LOGIN_AS_INVALID_TOKEN";

export const LOGIN_AS_TOKEN_ALREADY_USED_ERROR = "LOGIN_AS_TOKEN_ALREADY_USED";

export const LOGIN_AS_SELF_TARGET_ERROR = "LOGIN_AS_SELF_TARGET";

export const LOGIN_AS_OPERATOR_TARGET_ERROR = "LOGIN_AS_OPERATOR_TARGET";

export const LOGIN_AS_API_MESSAGES = {
  INVALID_JSON: "Invalid JSON.",
  MISSING_TOKEN: "Missing token.",
  TOKEN_ALREADY_USED: "This login-as link has already been used.",
  INVALID_OR_EXPIRED_TOKEN: "Invalid or expired login-as token.",
  UNABLE_TO_ACTIVATE: "Unable to activate login-as session.",
  UNABLE_TO_CLEAR: "Unable to clear login-as session.",
  UNABLE_TO_UPDATE_MODE: "Unable to update login-as mode.",
  ACTING_USER_NOT_FOUND: "Acting user not found in Waas.",
  TARGET_NOT_FOUND: "Target user not found.",
  CANNOT_LOGIN_AS_SELF: "Cannot login as yourself.",
  CANNOT_LOGIN_AS_OPERATOR: "Cannot login as another login-as operator.",
  NOT_CONFIGURED: "Login-as is not configured.",
  NOT_ALLOWED: "You are not allowed to login as other users.",
  UNABLE_TO_LOAD_OPERATORS: "Unable to load login-as operators.",
  INELIGIBLE_OPERATOR_EMAIL:
    "Only @infoplaza.nl or @infoplaza.com users can be login-as operators.",
  OPERATOR_USER_NOT_FOUND: "User not found.",
  ALREADY_OPERATOR: "User is already a login-as operator.",
  UNABLE_TO_ADD_OPERATOR: "Unable to add login-as operator.",
  OPERATOR_NOT_FOUND: "Login-as operator not found.",
} as const;

export const LOGIN_AS_UI_MESSAGES = {
  MISSING_TOKEN: "Missing login-as token.",
  UNABLE_TO_START: "Unable to start login-as session.",
  STARTING: "Starting login-as session…",
  PAGE_TITLE: "Login as user",
  REQUEST_FAILED: "Login-as request failed.",
  UNABLE_TO_CHANGE_MODE: "Unable to change mode.",
  UNABLE_TO_EXIT: "Unable to exit login-as.",
  EDITING_AS: "Editing as",
  VIEWING_AS: "Viewing as",
  RETURN_TO_VIEW: "Return to view mode",
  ENABLE_EDIT: "Enable edit mode",
  EXIT: "Exit login-as",
  FALLBACK_TARGET_LABEL: "user",
} as const;

export const LOGIN_AS_AUDIT_SUMMARIES = {
  ADDED_OPERATOR: "Added login-as operator",
  REMOVED_OPERATOR: "Removed login-as operator",
  MINTED_TOKEN: "Minted login-as token",
  ACTIVATED_SESSION: "Activated login-as session",
  CLEARED_SESSION: "Cleared login-as session",
  UPDATED_MODE: "Updated login-as mode",
} as const;
